<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 terms">
            <tnc></tnc>
          </div>
          <div class="md-layout-item md-size-100">
            <md-checkbox v-model="tnc_aim" @change="changeState">{{
              $t("I agree to AIM Robotics's TERMS & CONDITIONS")
            }}</md-checkbox>
          </div>
          <div v-if="showError" class="md-layout-item md-size-100 text-danger">
            {{ $t("You need to accept Terms & Conditions to continue.") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tnc } from "@/components";
import { mapFields } from "vuex-map-fields";

export default {
  components: { Tnc },
  data() {
    return {
      tnc_aim: false,
      showError: false
    };
  },
  computed: {
    ...mapFields("survey", ["surveyDraft"])
  },
  methods: {
    changeState() {
      if (this.tnc_aim) {
        this.showError = false;
      }
    },
    validate() {
      if (this.tnc_aim) {
        this.$emit("on-validated", true);
        return true;
      } else {
        this.showError = true;
        return false;
      }
    }
  }
};
</script>
<style>
.terms {
  background-color: #e6e6e6;
  overflow: auto;
  height: 400px;
  width: 100%;
}
</style>
